<template>
    <div class="container">
        <div class="filter_path">
            <el-form :inline="true" :model="params" class="form-inline">
                <el-form-item>
                    <el-date-picker class="filter_input" v-model="params.keyword" type="date" placeholder="单据日期" size="mini"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker class="filter_input" v-model="params.keyword" type="date" placeholder="单据日期" size="mini"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="供应商" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="客户" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="单据编号" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="审核状态" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-link type="danger" :underline="false">重置</el-link>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="operate_row">
            <div class="">
                <el-button type="danger" size="customize" @click="dialogVisible = !dialogVisible">新增</el-button>
                <el-button size="customize" plain>编辑</el-button>
                <el-button size="customize" plain>删除</el-button>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="单据日期"></el-table-column>
                <el-table-column label="供应商"></el-table-column>
                <el-table-column label="客户"></el-table-column>
                <el-table-column label="方数"></el-table-column>
                <el-table-column label="采购金额"></el-table-column>
                <el-table-column label="销售金额"></el-table-column>
                <el-table-column label="车号"></el-table-column>
                <el-table-column label="采购单号"></el-table-column>
                <el-table-column label="销售单号"></el-table-column>
                <el-table-column label="销售员"></el-table-column>
                <el-table-column label="审核人"></el-table-column>
                <el-table-column label="备注"></el-table-column>
            </el-table>
        </div>
        <!-- <div class="pagination_path">
            <pagination :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div> -->
        <div class="statistics">
            <span>合计：</span>
            <span>方数：21545</span>
            <span>采购金额：21545</span>
            <span>销售金额：21545</span>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .tab_box{
            display: flex; border-bottom: 2px solid #EEEFF2; padding: 9px 28px; margin-bottom: 16px;
            & > div{
                font-size: 16px; color: #222222; font-weight:bold; line-height:23px; position: relative; cursor: pointer;
                & + div { margin-left: 93px; }
            }
            .active::after{ display: block; content: ""; height: 4px; background: #155BD4; border-radius:4px; position: absolute; top: 100%; left: -8px; right: -8px;}
        }

        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            // .excel_btn{
            //     color: #8A8A8A; cursor: pointer;
            //     & + .excel_btn{ margin-left: 10px; }
            // }
        }
        .table_path{ flex: 1; }
        .statistics{
            background: #F7F8FA; padding: 14px 12px; line-height:22px; margin-top: 10px; display: flex; align-items: flex-start; font-size: 16px; color: #333333;
            span + span{ margin-left: 195px; }
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                tab : 1,
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
            }
        },
        methods:{
            changeTab(tab){
                this.$set(this,"tab",tab);
            },
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
